import config from 'SRC/config/config.json'

export const swapOptions = config.filters.swapOptions
